import { AfterViewInit, ChangeDetectorRef, Component, HostListener, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import * as Sentry from '@sentry/angular';
import { environment } from 'src/environments/environment';
import { UserService } from 'src/app/core/common-services/user.services';
import { LanguageService } from 'src/app/shared/services/language.service';
import { SignalrService } from 'src/app/shared/services/signalr.service';
import { NotificationMsg, NotificationService } from './../../core/common-services/notification.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements AfterViewInit, OnInit {
  title = 'Tal-Portal';
  versionLabel = 'v 1.0.8.2';
  currentSystemLanguage: string = 'ar';
  style: boolean = false;
  notifications: NotificationMsg[] = [];
  sidebarCollapsed = false;
  sidebarCollapsedMobile = true;
  isRtl = true;
  isMobile: boolean = false;

  @HostListener('window:resize')
  onResize() {
    this.checkScreenSize();
  }

  private checkScreenSize() {
    this.isMobile = window.innerWidth <= 768;
  }

  toggleSidebar() {
    this.sidebarCollapsed = !this.sidebarCollapsed;
  }
  toggleSidebarMobile() {
    this.sidebarCollapsedMobile = !this.sidebarCollapsedMobile;
    console.log(this.sidebarCollapsedMobile);
  }

  toggleLang() {
    this.isRtl = !this.isRtl;
  }
  constructor(
    public router: Router,
    public notificationService: NotificationService,
    private cdr: ChangeDetectorRef,
    private signalrService: SignalrService,
    private userService: UserService,
    private translate: TranslateService,
    private languageService: LanguageService
  ) {
    // Configure available languages
    this.translate.addLangs(['en', 'ar']);
    this.translate.setDefaultLang('ar');

    const browserLang = this.translate.getBrowserLang() || 'ar'; // fallback if undefined
    this.currentSystemLanguage = browserLang.match(/en|ar/) ? browserLang : 'ar';

    // Initialize RTL based on language service
    this.isRtl = this.languageService.currentLanguage === 'ar';
  }

  ngOnInit(): void {


    this.notifications = this.notificationService.notifications;
    // Update RTL status based on language service
    this.isRtl = this.languageService.currentLanguage === 'ar';

    if (this.userService.isLoggedIn()) {
      this.signalrService.startConnection(this.userService.currentUserCredantials.currentUsedInvestorAccountId);
    }
    this.checkScreenSize();

  }

  ngAfterViewInit() {
    this.cdr.detectChanges();
  }

  ngOnDestroy() {
    localStorage.removeItem('userNameEn');
    this.router.navigate(['/authentication/login']);
  }

  isHome() {
    return !this.router.url.includes('/home');
  }

  isLoggedIn() {
    return localStorage.getItem("authToken") != null;
  }

  removeNotification(notification: NotificationMsg) {
    this.notificationService.removeNotification(notification);
  }

  /** Send a test message and error to Sentry (for verification). Only when DSN is set. */
  sendSentryTest() {
    if (!environment.sentry?.dsn) {
      console.warn('[Sentry] No DSN configured. Set environment.sentry.dsn to test.');
      return;
    }
    Sentry.captureMessage('TAL-Portal manual test (log)', 'info');
    Sentry.captureException(new Error('TAL-Portal manual test (error)'));
    Sentry.flush(2000).then(() => console.log('[Sentry] Test events sent. Check Issues and Discover in Sentry.'));
  }

  get sentryTestEnabled(): boolean {
    return !!environment.sentry?.dsn && !environment.production;
  }

  // Switch language at runtime
  switchLanguage(lang: 'en' | 'ar') {
    this.currentSystemLanguage = lang;
    this.translate.use(lang);
    this.languageService.setLanguage(lang);
    this.isRtl = lang === 'ar';
    localStorage.setItem('lang', lang);
  }
}
